import React from 'react';
import Dashboard from '../Dashboard';
import UploadPassportMain from './UploadPassportMain'

export default function UploadPassport() {
    return (
        <div>
            <Dashboard cmp={<UploadPassportMain />} />
        </div>
    )
}

